﻿export { MapStreetView };
import { transform } from 'ol/proj';

/**
 * Class Identify
 */
const MapStreetView = function () {

    // Define this
    var myMapStreetView = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Coordinate wgs84 array
    this._coordinateWgs84 = [];

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------
    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Set coordinate to street view map
     * @param {array} arrayCoordinate, array of coordinate
     */
    this.SetCoordinate = function(arrayCoordinate)
    {
        // Get map srid 
        var mapSrid = myMapStreetView._mapSgs._settings._mapSettings.map_info.srs_srid.toString();

        // Transform coordinate
        myMapStreetView._coordinateWgs84 = transform([arrayCoordinate[0], arrayCoordinate[1]], 'EPSG:' + mapSrid, 'EPSG:4326');
    }

    /**
     * Show google street
     */
    this.ShowGoogleStreet = function()
    {
        var panorama;
        var latitude = myMapStreetView._coordinateWgs84[1];
        var longitude = myMapStreetView._coordinateWgs84[0];

        panorama = new google.maps.StreetViewPanorama(
            document.getElementById('id-modal-body-streetview'),
            {
                position: { lat: latitude, lng: longitude },
                pov: { heading: 165, pitch: 0 },
                zoom: 1
            });
        $('#id-modal-streetview').css({ 'display': 'block' });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------
    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Click btn view street map modal
     */
    $('#id-offcanvas-body-layer-detail-open-street-view-btn').on('click', function()
    {
        myMapStreetView.ShowGoogleStreet();
    });

    /**
     * Close modal street view map
     */
    $('#id-modal-streetview-cancel').on('click', function()
    {
        $('#id-modal-streetview').css({ 'display': 'none' });
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init map street view information
 * @param {ol.map} map, ol map
 */
MapStreetView.prototype.Init = function (MapSgs) {

    // Keep map sgs
    this._mapSgs = MapSgs;
};
